export default __webpack_public_path__ + "static/media/dashBg.6afd5ccf.png";